import { Container, Grid, ThemeProvider, createTheme } from '@mui/material';
import './App.css';
import Profile from './components/Profile/Profile';
import { BrowserRouter as Router} from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './components/Home/Home';
import About from './components/About/About';
import Projects from './components/Projects/Projects';
import Skill from './components/Skill/Skill';
import Contact from './components/Contact/Contact';
import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

// The classroom portal (and its database client) only downloads when someone opens it.
const PortalLogin = lazy(() => import('./components/Portal/PortalLogin'));
const StudentPortal = lazy(() => import('./components/Portal/StudentPortal'));
const TeacherPortal = lazy(() => import('./components/Portal/TeacherPortal'));
const portal = (element) => <Suspense fallback={<div style={{ minHeight: '100vh', background: '#f5f5f8' }} />}>{element}</Suspense>;

// MUI components default to Roboto; keep them on the site font.
const theme = createTheme({
  typography: { fontFamily: "'Poppins', system-ui, -apple-system, 'Segoe UI', sans-serif" },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/classroom" element={portal(<PortalLogin role="student" />)} />
          <Route path="/classroom/*" element={portal(<StudentPortal />)} />
          <Route path="/me" element={portal(<PortalLogin role="teacher" />)} />
          <Route path="/me/*" element={portal(<TeacherPortal />)} />
          <Route
            path="*"
            element={
              <>
                <Header />
                <Container>
                  <Grid container className="grid-container" id="home">
                    <Grid item xs={12} sm md={3.55} lg={3} sx={{ order: { xs: 2, sm: 1 } }}>
                      <Profile />
                    </Grid>
                    <Grid item xs sx={{ order: { xs: 1, sm: 2 } }}>
                      <div className="main-content">
                        <Home />
                      </div>
                    </Grid>
                  </Grid>
                </Container>
                <section id="about"><About /></section>
                <section id="project"><Projects /></section>
                <section id="skill"><Skill /></section>
                <section id="contact"><Contact /></section>
                <Footer />
              </>
            }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
